export enum SmsVerificationErrorEnum {
  CodeExpired = 'verification-code-expired',
  CodeUsageLimitReached = 'code-usages-limit-exceeded',
  IncorrectCode = 'incorrect-code',
  IncorrectPhoneNumber = 'incorrect-phone-number',
  SentSmsLimitReached = 'sent-sms-limit-exceeded',
  VerificationAlreadyPassed = 'sms-verification-already-passed',
  VerificationNotInitiated = 'sms-verification-not-initiated',
}
